var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 540,
    height: 156,
    viewBox: "0 0 540 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M520 156H20C9.005 156 0 147.22 0 136.5V19.5C0 8.77989 9.005 1.52588e-05 20 1.52588e-05H520C530.995 1.52588e-05 540 8.77989 540 19.5V136.5C540 147.22 530.995 156 520 156Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M520 3.12488C529.26 3.12488 536.795 10.4715 536.795 19.5V136.5C536.795 145.529 529.26 152.875 520 152.875H20C10.74 152.875 3.205 145.529 3.205 136.5V19.5C3.205 10.4715 10.74 3.12488 20 3.12488H520ZM520 1.52588e-05H20C9.005 1.52588e-05 0 8.77989 0 19.5V136.5C0 147.22 9.005 156 20 156H520C530.995 156 540 147.22 540 136.5V19.5C540 8.77989 530.995 1.52588e-05 520 1.52588e-05Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.74 29.4011C40.565 30.6003 39.885 32.4675 39.885 34.8855V121.134C39.885 123.552 40.565 125.419 41.74 126.618L42.03 126.882L91.6 78.5703V77.4296L42.03 29.1183L41.74 29.4011Z",
    fill: "url(#paint0_linear_303_2352)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.105 94.6822L91.5999 78.5703V77.4296L108.125 61.3177L108.495 61.5273L128.065 72.3839C133.65 75.4649 133.65 80.5349 128.065 83.6354L108.495 94.4726L108.105 94.6822Z",
    fill: "url(#paint1_linear_303_2352)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.495 94.4726L91.6 78L41.74 126.618C43.595 128.52 46.62 128.749 50.06 126.847L108.495 94.4726Z",
    fill: "url(#paint2_linear_303_2352)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.495 61.5274L50.06 29.1525C46.62 27.2708 43.595 27.4999 41.74 29.4011L91.6 78L108.495 61.5274Z",
    fill: "url(#paint3_linear_303_2352)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M189.67 39.9506C189.67 43.2071 188.67 45.8152 186.7 47.7604C184.435 50.0662 181.485 51.2265 177.87 51.2265C174.415 51.2265 171.465 50.0467 169.045 47.7214C166.62 45.3619 165.41 42.4661 165.41 39C165.41 35.5339 166.62 32.6381 169.045 30.2981C171.465 27.9533 174.415 26.7735 177.87 26.7735C179.59 26.7735 181.23 27.1196 182.795 27.7631C184.355 28.4115 185.625 29.289 186.545 30.3712L184.455 32.4285C182.85 30.5809 180.665 29.6693 177.87 29.6693C175.35 29.6693 173.165 30.5272 171.31 32.2579C169.475 33.9934 168.555 36.2407 168.555 39C168.555 41.7592 169.475 44.0261 171.31 45.7616C173.165 47.4727 175.35 48.3502 177.87 48.3502C180.545 48.3502 182.795 47.4727 184.57 45.7421C185.74 44.5965 186.405 43.017 186.58 40.9987H177.87V38.181H189.49C189.63 38.7904 189.67 39.3802 189.67 39.9506Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.105 30.1811H197.19V37.5911H207.03V40.4088H197.19V47.8188H208.105V50.6902H194.1V27.3097H208.105V30.1811Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M221.115 50.6902H218.025V30.1811H211.33V27.3097H227.815V30.1811H221.115V50.6902Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M239.745 50.6902V27.3097H242.83V50.6902H239.745Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.505 50.6902H253.44V30.1811H246.72V27.3097H263.225V30.1811H256.505V50.6902Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M294.435 47.6824C292.07 50.0467 289.14 51.2265 285.645 51.2265C282.13 51.2265 279.2 50.0467 276.835 47.6824C274.475 45.3229 273.3 42.4271 273.3 39C273.3 35.5729 274.475 32.6771 276.835 30.3176C279.2 27.9532 282.13 26.7735 285.645 26.7735C289.12 26.7735 292.05 27.9532 294.415 30.3371C296.795 32.7161 297.97 35.5924 297.97 39C297.97 42.4271 296.795 45.3229 294.435 47.6824ZM279.12 45.7226C280.9 47.4727 283.065 48.3502 285.645 48.3502C288.205 48.3502 290.39 47.4727 292.15 45.7226C293.925 43.9725 294.825 41.7251 294.825 39C294.825 36.2749 293.925 34.0275 292.15 32.2774C290.39 30.5273 288.205 29.6497 285.645 29.6497C283.065 29.6497 280.9 30.5273 279.12 32.2774C277.345 34.0275 276.445 36.2749 276.445 39C276.445 41.7251 277.345 43.9725 279.12 45.7226Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M302.305 50.6902V27.3097H306.055L317.715 45.4935H317.85L317.715 40.9987V27.3097H320.8V50.6902H317.58L305.37 31.6095H305.235L305.37 36.1237V50.6902H302.305Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M272.54 84.8348C263.145 84.8348 255.47 91.8061 255.47 101.424C255.47 110.965 263.145 118.009 272.54 118.009C281.955 118.009 289.63 110.965 289.63 101.424C289.63 91.8061 281.955 84.8348 272.54 84.8348ZM272.54 111.477C267.385 111.477 262.95 107.328 262.95 101.424C262.95 95.4428 267.385 91.3673 272.54 91.3673C277.695 91.3673 282.15 95.4428 282.15 101.424C282.15 107.328 277.695 111.477 272.54 111.477ZM235.295 84.8348C225.88 84.8348 218.225 91.8061 218.225 101.424C218.225 110.965 225.88 118.009 235.295 118.009C244.705 118.009 252.365 110.965 252.365 101.424C252.365 91.8061 244.705 84.8348 235.295 84.8348ZM235.295 111.477C230.135 111.477 225.685 107.328 225.685 101.424C225.685 95.4428 230.135 91.3673 235.295 91.3673C240.45 91.3673 244.885 95.4428 244.885 101.424C244.885 107.328 240.45 111.477 235.295 111.477ZM190.975 89.9194V96.9687H208.24C207.735 100.908 206.385 103.803 204.315 105.822C201.795 108.259 197.87 110.965 190.975 110.965C180.35 110.965 172.03 102.604 172.03 92.2448C172.03 81.8855 180.35 73.5248 190.975 73.5248C196.72 73.5248 200.9 75.7137 203.985 78.551L209.08 73.5833C204.765 69.5663 199.025 66.4805 190.975 66.4805C176.405 66.4805 164.16 78.0391 164.16 92.2448C164.16 106.451 176.405 118.009 190.975 118.009C198.85 118.009 204.765 115.494 209.415 110.775C214.18 106.129 215.665 99.5963 215.665 94.3216C215.665 92.6836 215.525 91.1772 215.275 89.9194H190.975ZM372.205 95.3843C370.8 91.6745 366.465 84.8348 357.635 84.8348C348.885 84.8348 341.6 91.5575 341.6 101.424C341.6 110.716 348.81 118.009 358.475 118.009C366.29 118.009 370.8 113.363 372.655 110.658L366.855 106.889C364.92 109.649 362.285 111.477 358.475 111.477C354.69 111.477 351.975 109.785 350.235 106.451L372.99 97.2709L372.205 95.3843ZM349.005 100.908C348.81 94.5117 354.1 91.2357 357.89 91.2357C360.86 91.2357 363.38 92.6836 364.22 94.7555L349.005 100.908ZM330.51 117H337.99V68.2501H330.51V117ZM318.26 88.5301H318.01C316.33 86.5898 313.125 84.8348 309.065 84.8348C300.545 84.8348 292.755 92.1278 292.755 101.478C292.755 110.775 300.545 118.009 309.065 118.009C313.125 118.009 316.33 116.24 318.01 114.241H318.26V116.62C318.26 122.962 314.785 126.37 309.18 126.37C304.61 126.37 301.775 123.152 300.605 120.447L294.1 123.094C295.975 127.491 300.94 132.902 309.18 132.902C317.95 132.902 325.35 127.871 325.35 115.63V85.844H318.26V88.5301ZM309.705 111.477C304.55 111.477 300.235 107.27 300.235 101.478C300.235 95.6329 304.55 91.3673 309.705 91.3673C314.785 91.3673 318.79 95.6329 318.79 101.478C318.79 107.27 314.785 111.477 309.705 111.477ZM407.225 68.2501H389.335V117H396.795V98.5287H407.225C415.51 98.5287 423.635 92.6836 423.635 83.387C423.635 74.0952 415.49 68.2501 407.225 68.2501ZM407.42 91.7476H396.795V75.0312H407.42C412.99 75.0312 416.17 79.5406 416.17 83.387C416.17 87.1602 412.99 91.7476 407.42 91.7476ZM453.535 84.7422C448.145 84.7422 442.54 87.0627 440.235 92.2058L446.855 94.9114C448.28 92.2058 450.9 91.3283 453.67 91.3283C457.54 91.3283 461.465 93.5952 461.525 97.5976V98.1094C460.175 97.349 457.285 96.2228 453.73 96.2228C446.6 96.2228 439.335 100.05 439.335 107.192C439.335 113.724 445.175 117.931 451.74 117.931C456.76 117.931 459.53 115.723 461.27 113.154H461.525V116.922H468.73V98.2216C468.73 89.5782 462.11 84.7422 453.535 84.7422ZM452.635 111.457C450.195 111.457 446.795 110.277 446.795 107.328C446.795 103.555 451.035 102.107 454.705 102.107C457.99 102.107 459.53 102.814 461.525 103.745C460.94 108.259 456.955 111.457 452.635 111.457ZM494.98 85.8098L486.405 106.943H486.15L477.285 85.8098H469.24L482.56 115.343L474.96 131.776H482.755L503.28 85.8098H494.98ZM427.735 117H435.215V68.2501H427.735V117Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_303_2352",
    x1: 87.1988,
    y1: 122.032,
    x2: 21.7684,
    y2: 54.9241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_303_2352",
    x1: 135.337,
    y1: 77.9945,
    x2: 38.5499,
    y2: 77.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_303_2352",
    x1: 99.308,
    y1: 69.0452,
    x2: 10.5791,
    y2: -21.9588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_303_2352",
    x1: 29.1892,
    y1: 155.313,
    x2: 68.8106,
    y2: 114.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/Google Play.99b6d68fb01e40f7171090d5c68208bf.svg";
export { ForwardRef as ReactComponent };